import React from 'react';
import RegistrationFormContainer from './RegistrationFormContainer';

export const RegistrationBlock = (props) => {
  return <RegistrationFormContainer {...props} />;
};
